import {
  ApplicationRejectReason,
  ApplicationSortingField,
  StatusCategoryTab,
  ApplicationsTableColumnsTitle,
  ApplicationsTableRejectReason,
  ApplicationsTableStatus,
  ApplicationStatus,
  ApplicationsStatusCategory,
  InactiveStatusTab,
  ApplicationsInactiveStatus,
} from 'components/applications/applications.enums';
import { ApplicationsPageFilters } from 'components/applications/applications.types';

export const APPLICATIONS_TABLE_COLUMNS = [
  {
    title: ApplicationsTableColumnsTitle.ID,
    sortField: ApplicationSortingField.DisplayId,
  },
  {
    title: ApplicationsTableColumnsTitle.Borrower,
  },
  {
    title: ApplicationsTableColumnsTitle.CoBorrower,
  },
  {
    title: ApplicationsTableColumnsTitle.ApplicationDate,
    sortField: ApplicationSortingField.CreatedAt,
  },
  {
    title: ApplicationsTableColumnsTitle.LoanAmount,
    sortField: ApplicationSortingField.LoanAmount,
  },
  {
    title: ApplicationsTableColumnsTitle.StatusName,
    tab: StatusCategoryTab.Active,
  },
  {
    title: ApplicationsTableColumnsTitle.ActionNeeded,
    tab: StatusCategoryTab.Active,
  },
  {
    title: ApplicationsTableColumnsTitle.LoanDecision,
    tab: StatusCategoryTab.Inactive,
  },
];
export const APPLICATIONS_TABLE_SORTING_FIELDS = [
  ApplicationSortingField.DisplayId,
  ApplicationSortingField.CreatedAt,
  ApplicationSortingField.StatusName,
];
export const MAX_APPLICATIONS_PER_PAGE = 10;
export const APPLICATIONS_TABLE_COLUMNS_AMOUNT = 7;
export const APPLICATIONS_TABLE_COLUMNS_AMOUNT_INACTIVE = 6;
export const SEARCH_DEBOUNCE_VALUE = 1000;
export const MIN_SYMBOLS_FOR_SEARCH = 3;
export const APPLICATION_TABLE_EMPTY_VALUE = '-';
export const APPLICATIONS_STATUSES_MAPPING = {
  [ApplicationStatus.Active]: ApplicationsTableStatus.Active,
  [ApplicationStatus.Pitched]: ApplicationsTableStatus.Pitched,
  [ApplicationStatus.Purgatory]: ApplicationsTableStatus.Processing,
  [ApplicationStatus.Processing]: ApplicationsTableStatus.Processing,
  [ApplicationStatus.Compliance]: ApplicationsTableStatus.Processing,
  [ApplicationStatus.ReadyToSubmit]: ApplicationsTableStatus.Processing,
  [ApplicationStatus.Underwriting]: ApplicationsTableStatus.Underwriting,
  [ApplicationStatus.NeedMoreInfo]: ApplicationsTableStatus.Underwriting,
  [ApplicationStatus.NMICompleted]: ApplicationsTableStatus.Underwriting,
  [ApplicationStatus.PendingFunding]: ApplicationsTableStatus.Approved,
  [ApplicationStatus.Approved]: ApplicationsTableStatus.Funded,
  [ApplicationStatus.Rejected]: ApplicationsTableStatus.Rejected,
};
export const APPLICATIONS_REJECT_REASON_MAPPING = {
  [ApplicationRejectReason.LenderDecline]: ApplicationsTableRejectReason.UnableToQualify,
  [ApplicationRejectReason.DidNotFundLenderApproved]: ApplicationsTableRejectReason.ApprovedDidNotFund,
  [ApplicationRejectReason.TUD]: ApplicationsTableRejectReason.ConditionallyApproved,
  [ApplicationRejectReason.AutoDeclinePlusCredit]: ApplicationsTableRejectReason.UnableToQualifyCredit,
  [ApplicationRejectReason.AutoDeclinePlusFrozenOrLocked]: ApplicationsTableRejectReason.UnableToQualifyFrozenOrLocked,
  [ApplicationRejectReason.AutoDeclinePlusFraud]: ApplicationsTableRejectReason.UnableToQualify,
  [ApplicationRejectReason.Ineligible]: ApplicationsTableRejectReason.UnableToQualifyIneligible,
  [ApplicationRejectReason.Fraud]: ApplicationsTableRejectReason.UnableToQualify,
  [ApplicationRejectReason.Credit]: ApplicationsTableRejectReason.UnableToQualifyCredit,
  [ApplicationRejectReason.DTI]: ApplicationsTableRejectReason.UnableToQualifyDTI,
  [ApplicationRejectReason.NotReadyToProceed]: ApplicationsTableRejectReason.ConditionallyApprovedNRTP,
  [ApplicationRejectReason.NRC]: ApplicationsTableRejectReason.ConditionallyApprovedADNR,
};
export const DEFAULT_APPLICATIONS_TABLE_FILTERS: ApplicationsPageFilters = {
  currentTab: StatusCategoryTab.Active,
  pageIndex: 0,
  pageSize: MAX_APPLICATIONS_PER_PAGE,
  sortField: ApplicationSortingField.CreatedAt,
  isSortDesc: true,
  search: '',
  statusCategory: ApplicationsStatusCategory.Active,
};
export const APPLICATIONS_TABLE_TOOLTIP_TEXT = `Active – HFS has received the borrower(s) inquiry\n\nPitched – HFS presented loan offer(s) to the borrower(s)\n\nProcessing – Borrower(s) accepted loan terms and must submit required documentation/information for final loan decision\n\nUnderwriting – Awaiting final loan decision\n\nPending Approved – YAY! The Loan is Approved. Borrower(s) must e-sign closing documents that were emailed to them in order to fund their loan`;
export const MAP_INACTIVE_STATUS_TAB_TO_INACTIVE_STATUS: Record<InactiveStatusTab, ApplicationsInactiveStatus> = {
  [InactiveStatusTab.AllInactive]: ApplicationsInactiveStatus.All,
  [InactiveStatusTab.Funded]: ApplicationsInactiveStatus.Funded,
  [InactiveStatusTab.WillNotFund]: ApplicationsInactiveStatus.Rejected,
};

export const MAP_INACTIVE_STATUS_TO_INACTIVE_STATUS_TAB: Record<ApplicationsInactiveStatus, InactiveStatusTab> = {
  [ApplicationsInactiveStatus.All]: InactiveStatusTab.AllInactive,
  [ApplicationsInactiveStatus.Funded]: InactiveStatusTab.Funded,
  [ApplicationsInactiveStatus.Rejected]: InactiveStatusTab.WillNotFund,
};
